import { render, staticRenderFns } from "./MakePaymentPage.vue?vue&type=template&id=556d0f1c&scoped=true&"
import script from "./MakePaymentPage.vue?vue&type=script&lang=ts&"
export * from "./MakePaymentPage.vue?vue&type=script&lang=ts&"
import style0 from "./MakePaymentPage.vue?vue&type=style&index=0&id=556d0f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556d0f1c",
  null
  
)

export default component.exports